import styled from "styled-components";

export const StepButtons = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

export const StepButton = styled.button`
  padding: 8px 20px;
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  background-color: ${(props) => (props.active ? "#203b34" : "#e9ecef")};
  color: ${(props) => (props.active ? "#fff" : "#495057")};
  border: 1px solid #ced4da;
  border-right: ${(props) => (props.first ? "none" : "1px solid #ced4da")};
  border-radius: ${(props) => (props.first ? "4px 0 0 4px" : "0 4px 4px 0")};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${(props) => (props.active ? "#203b34" : "#d3d6da")};
  }
`;

export const TimelineSection = styled.div`
  margin-bottom: 30px;
`;

export const TimelineTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #203b34;
  margin-bottom: 15px;
`;

export const DayLegend = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 5px;
  margin-left: 315px;
`;

export const DayLegendItem = styled.div`
  width: 50px;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  padding-bottom: 2px;
`;

export const ParcelRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 15px;
`;

export const HoursCounter = styled.div`
  padding: 6px 12px;
  background: ${(props) => props.color}20;
  border: 2px solid ${(props) => props.color};
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.color};
  white-space: nowrap;
`;

export const ParcelLabel = styled.div`
  width: 300px;
  flex: 0 0 300px;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: ${(props) => props.color}15;
  border-radius: 6px;
  border-left: 4px solid ${(props) => props.color};

  span {
    font-size: 12px;
    font-weight: normal;
    color: #666;
  }
`;

export const ParcelTimeline = styled.div`
  flex: 1;
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;

export const DayBox = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 4px;
  border: 2px solid
    ${(props) =>
      props.isCompensation
        ? "#15ff00"
        : props.isExtraDay
          ? "#f06292"
          : props.color};
  background: ${(props) => {
    if (props.isRemoved) return "#f5f5f5";
    if (props.isCompensation) {
      return props.isFilled ? "#00ff4c" : "#fff3e0";
    }
    if (props.isExtraDay) {
      return props.isFilled ? "#f06292" : "#fce4ec";
    }
    if (!props.isFilled) {
      if (props.canRestore) return `${props.color}10`;
      return "#fff";
    }
    if (props.percentage >= 100) return props.color;
    return `linear-gradient(to top, ${props.color} ${props.percentage}%, #fff ${props.percentage}%)`;
  }};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 600;
  color: ${(props) => {
    if (props.isRemoved) return "#999";
    if (props.isCompensation) return props.isFilled ? "#fff" : "#ff9800";
    if (props.isExtraDay) return props.isFilled ? "#fff" : "#f06292";
    if (props.canRestore && !props.isFilled) return props.color;
    return props.percentage >= 50 ? "#fff" : props.color;
  }};
  position: relative;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  padding: 4px;
  cursor: ${(props) =>
    props.isCompensation
      ? "not-allowed"
      : props.isFilled || props.isRemoved || props.canRestore
        ? "pointer"
        : "default"};
  opacity: ${(props) =>
    props.isRemoved ? 0.5 : props.isCompensation ? 0.7 : 1};

  &:hover {
    transform: ${(props) =>
      !props.isCompensation &&
      (props.isFilled || props.isRemoved || props.canRestore)
        ? "scale(1.1)"
        : "none"};
    box-shadow: ${(props) =>
      !props.isCompensation &&
      (props.isFilled || props.isRemoved || props.canRestore)
        ? "0 2px 8px rgba(0, 0, 0, 0.15)"
        : "none"};
    z-index: ${(props) =>
      !props.isCompensation &&
      (props.isFilled || props.isRemoved || props.canRestore)
        ? 10
        : 1};
  }

  .day-name {
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    margin-bottom: 2px;
    .day-name {
      font-size: 8px;
    }

    .day-number {
      font-size: 11px;
    }
  }

  .hours {
    font-size: 8px;
    font-weight: 600;
    line-height: 1;
    margin-top: 4px;
    text-shadow: ${(props) =>
      props.percentage >= 50 ? "0 1px 2px rgba(0,0,0,0.2)" : "none"};
  }

  .removed-icon {
    font-size: 16px;
    margin-top: 2px;
    opacity: 0.7;
  }
`;
